// Quem pode o quê no painel. Espelha backend/api/v1/auth/permissions.py:
// proprietário e administrador podem tudo; o funcionário pode o que está marcado
// no cadastro dele (allowed_modules). O servidor confere de novo em cada rota —
// isto aqui só serve para a tela não oferecer o que seria recusado.

const ACESSO_TOTAL = ["proprietario", "administrador"];

/** Usuário logado, como o Dashboard mantém no localStorage (atualizado por /auth/me). */
export function usuarioLogado() {
  try {
    return JSON.parse(localStorage.getItem("user") || "null");
  } catch {
    return null;
  }
}

export const temAcessoTotal = (usuario) => ACESSO_TOTAL.includes((usuario?.role || "").toLowerCase());

/** `chave` é uma permissão ou várias — com várias, basta ter uma. */
export function temPermissao(usuario, chave) {
  if (!usuario) return false;
  if (temAcessoTotal(usuario)) return true;
  const marcadas = Array.isArray(usuario.allowed_modules) ? usuario.allowed_modules : [];
  return [].concat(chave).some((c) => marcadas.includes(c));
}

/** O usuário logado tem a permissão? */
export const possoAgora = (chave) => temPermissao(usuarioLogado(), chave);
